import CartSummary from './components/CartSummary';

const Summary = (props) => {
  const { cart } = props;
  return <CartSummary cart={cart} />;
};

export default Summary;
